export default __webpack_public_path__ + "static/media/star-green.2bde97c8.svg";